import { Box, Typography } from "@mui/material";

import { Notification } from "../../../types";

import NotificationItem from "./NotificationItem";
import EmptyNotificationsFigure from "./EmptyNotificationsFigure";

type Props = {
  data: any;
  lastSeen: number | null;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
};

const NotificationsList = ({ data, lastSeen, fetchNextPage, hasNextPage, isFetchingNextPage }: Props) => {
  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const target = event.currentTarget;
    const bottom = target.scrollHeight - target.scrollTop - target.clientHeight < 5;
    if (bottom && hasNextPage && !isFetchingNextPage) fetchNextPage();
  };

  const hasNotifications = data?.pages?.some((page: any) => page.data.items.length > 0);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: "48px",
        flex: 1,
        justifyContent: hasNotifications ? "flex-start" : "center",
        alignItems: hasNotifications ? "flex-start" : "center",
        overflowY: "auto",
      }}
      onScroll={handleScroll}
    >
      {!hasNotifications && <EmptyNotificationsFigure />}
      {data?.pages?.map((page: any) =>
        page.data.items.map((notification: Notification) => (
          <NotificationItem key={notification.id} notification={notification} lastSeenTime={lastSeen} />
        ))
      )}
      {isFetchingNextPage && <Typography>...</Typography>}
    </Box>
  );
};

export default NotificationsList;
